import React from "react";

import { Button, makeStyles, Box } from "@material-ui/core";

import { CustomCardContent } from "../card-content/CardContent";
import { SimpleCardHeader } from "../card/card-header/CardHeader";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles({
    heading: {
        fontSize: "26px",
        fontWeight: 600,
        border: 0,
        width: "100%"
    },

    cardTitle: {
        fontSize: "20px",
        fontWeight: 600,
        marginRight: "15px",
    },

    cardHeader: {
        display: "flex",
        justifyContent: "spaceBetween",
        width: "100%"
    },

    cardHeaderLeft: {
        display: "flex",
    },

    actionButton: {
        zIndex: 1,
        width: "100%",
        textAlign: "end"
    }
})

export default function TitledCard(props) {

    const classes = useStyles(props)
    const [t, i18n] = useTranslation()
    return (
        <CustomCardContent>
            <SimpleCardHeader>
                <Box className={classes.cardHeader}>
                    <Box className={classes.cardHeaderLeft}>
                        <Box className={classes.cardTitle}>{props.title}</Box>
                    </Box>
                </Box>
                <Box className={classes.actionButton}>
                    {props.actionButton ? props.actionButton : null}
                </Box>
                {props.editable ? <Button onClick={props.handleEditClick} variant="outlined">{props.isEditing ? t('common.done') : t('common.edit')}</Button> : null}

            </SimpleCardHeader>
            {props.children}
        </CustomCardContent>
    );
}

